export default __webpack_public_path__ + "static/media/call-icon.403dafe5.svg";